<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one v-show="noticeInfo.notice_title" class="-margin-md">{{noticeInfo.notice_title}}</heading-one>

    <section>
      <p v-show="noticeInfo.notice_date" class="-textright">{{noticeInfo.notice_date | ymdDateFormat('/')}}</p>
      <p v-html="noticeInfo.notice_body.replace(/(¥n|\n|¥n¥r|\n\r)/g,'<br/>')"></p>
    </section>

    <btngroup-single class="-margin-lg">
      <btn-main class="-normal" routerName="mb002">
        メッセージ一覧へ
      </btn-main>
    </btngroup-single>

  </div><!-- container -->
</template>

<script>
import { getNoticeInfoLambdaInvoke } from '../utils/LambdaHelper'
import HeadingOne from '../components/heading/HeadingOne'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne
  },
  name: 'Mb-003',
  metaInfo: {
    title: '  ',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,メッセージ'}
    ]
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'メッセージ',
        routerName: 'mb002'
      }],
      noticeInfo: {
        notice_id: this.$route.params.notice_id,
        status: '',
        account_id: '',
        notice_date: '',
        importance: '',
        notice_title: '',
        notice_body: ''
      }
    }
  },
  mounted () {
    try {
      getNoticeInfoLambdaInvoke(this.noticeInfo).then(res => {
        let resBody = JSON.parse(res.body)
        for (let key in resBody) {
          if (this.noticeInfo.hasOwnProperty(key)) {
            this.noticeInfo[key] = resBody[key].toString().trim()
          }
        }
        document.title = this.noticeInfo.notice_title + ' | メッセージ一覧 | au PAY スマートローン'
        this.breadcrumbItems.push({
          text: this.noticeInfo.notice_title,
          active: true
        })
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Mb003.vue